import { Info, Files, FileStack } from 'lucide-react';

import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Table, TableBody, TableCell, TableRow } from '@/components/ui/table';
import { roleOptionsDict } from 'src/pages/SoftwareEscrowOnboarding/model';
import { AgreementFormEnum } from 'src/graphql/schema';
import { useSoftwareEscrow } from 'src/context/software-escrow';

const agreementFormMap = {
  [AgreementFormEnum.Bipartite]: {
    icon: Files,
    title: 'Bipartite',
    description: 'The beneficiary won’t sign, but can still request a release if certain conditions are met.',
  },
  [AgreementFormEnum.Tripartite]: {
    icon: FileStack,
    title: 'Tripartite',
    description: 'The agreement will be signed by the depositor, the beneficiary, and the escrow agent.',
  },
};

const BasicsCard = () => {
  const {
    softwareEscrow: { currentCompanyRole, agreement },
  } = useSoftwareEscrow();

  const { icon: RoleIcon, title: roleTitle, description: roleDescription } = roleOptionsDict[currentCompanyRole!];
  const {
    icon: AgreementFormIcon,
    title: agreementFormTitle,
    description: agreementFormDescription,
  } = agreementFormMap[agreement!.agreementForm!];

  return (
    <Card>
      <CardHeader className="relative">
        <span className="absolute top-6 right-6 italic text-xs text-gray-400">Non-editable fields</span>
        <CardTitle className="flex items-center gap-2 text-xl">
          <Info className="size-6" />
          Basics
        </CardTitle>
        <CardDescription>Your role and agreement form</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="rounded-sm border border-border grow-1 overflow-hidden">
          <Table>
            <TableBody>
              <TableRow>
                <TableCell className="w-[190px] font-semibold">Role</TableCell>
                <TableCell className="w-[85px]">:</TableCell>
                <TableCell>
                  <div className="flex items-center gap-2 min-w-[250px]">
                    <div className="size-10 rounded-lg bg-muted flex items-center justify-center shrink-0">
                      <RoleIcon className="size-4 text-foreground" />
                    </div>
                    <div>
                      <div className="font-medium text-sm">{roleTitle}</div>
                      <div className="text-xs text-foreground/80">{roleDescription}</div>
                    </div>
                  </div>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="w-[190px] font-semibold">Agreement form</TableCell>
                <TableCell className="w-[85px]">:</TableCell>
                <TableCell>
                  <div className="flex items-center gap-2">
                    <div className="size-10 rounded-lg bg-muted flex items-center justify-center shrink-0">
                      <AgreementFormIcon className="size-4 text-foreground" />
                    </div>
                    <div>
                      <div className="font-medium text-sm capitalize">{agreementFormTitle}</div>
                      <div className="text-xs text-foreground/80">{agreementFormDescription}</div>
                    </div>
                  </div>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </div>
      </CardContent>
    </Card>
  );
};

export default BasicsCard;
